/* ==========================================
   wishlist.js — Favoritos S+J (localStorage)
   - Guarda productos en el navegador (sin backend).
   - Togglea el estado de los corazones [data-wishlist-toggle].
   - Actualiza el contador del header [data-wishlist-count].
   - Renderiza la página de favoritos [data-wishlist-grid].
   ========================================== */

(function () {
  var KEY = 'sj_wishlist_v1';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: list.length } }));
  }

  function has(handle) {
    return read().some(function (it) { return it.h === handle; });
  }

  function itemFromButton(btn) {
    return {
      h: btn.getAttribute('data-handle') || '',
      t: btn.getAttribute('data-title') || '',
      p: btn.getAttribute('data-price') || '',
      i: btn.getAttribute('data-image') || '',
      u: btn.getAttribute('data-url') || '#',
      b: btn.getAttribute('data-brand') || ''
    };
  }

  function toggle(item) {
    if (!item.h) return false;
    var list = read();
    var idx = -1;
    for (var n = 0; n < list.length; n++) { if (list[n].h === item.h) { idx = n; break; } }
    var nowActive;
    if (idx >= 0) { list.splice(idx, 1); nowActive = false; }
    else { list.unshift(item); nowActive = true; }
    write(list);
    return nowActive;
  }

  /* ---- UI sync ---- */

  function syncButtons() {
    var list = read();
    var active = {};
    list.forEach(function (it) { active[it.h] = true; });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = !!active[btn.getAttribute('data-handle')];
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function updateCount() {
    var count = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.hidden = count === 0;
    });
  }

  /* ---- Favorites page rendering ---- */

  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderGrid() {
    var grids = document.querySelectorAll('[data-wishlist-grid]');
    if (!grids.length) return;
    var empties = document.querySelectorAll('[data-wishlist-empty]');
    var list = read();

    if (!list.length) {
      grids.forEach(function (g) { g.innerHTML = ''; g.hidden = true; });
      empties.forEach(function (el) { el.hidden = false; });
      return;
    }
    empties.forEach(function (el) { el.hidden = true; });

    var html = list.map(function (it) {
      var thumb = it.i
        ? '<div class="sj-card__thumb"><img src="' + esc(it.i) + '" alt="' + esc(it.t) + '" loading="lazy"></div>'
        : '<div class="sj-card__thumb"><div class="sj-card__bg" style="background:linear-gradient(160deg,#F4EAD3 0%,#A9462F 100%)"></div></div>';
      var brand = it.b ? '<div class="sj-card__brand">' + esc(it.b) + '</div>' : '';
      var price = it.p ? '<div class="sj-card__prices"><span class="sj-card__price">' + esc(it.p) + '</span></div>' : '';
      return '' +
        '<div class="sj-card sj-fav-card">' +
          '<a class="sj-fav-card__link" href="' + esc(it.u) + '">' + thumb + '</a>' +
          '<button type="button" class="sj-fav-remove" data-wishlist-toggle data-handle="' + esc(it.h) + '" data-title="' + esc(it.t) + '" data-price="' + esc(it.p) + '" data-image="' + esc(it.i) + '" data-url="' + esc(it.u) + '" data-brand="' + esc(it.b) + '" aria-label="Quitar de favoritos">Quitar ✕</button>' +
          '<a class="sj-fav-card__link" href="' + esc(it.u) + '">' + brand +
            '<div class="sj-card__name">' + esc(it.t) + '</div>' + price +
          '</a>' +
        '</div>';
    }).join('');

    grids.forEach(function (g) { g.innerHTML = html; g.hidden = false; });
  }

  function refresh() {
    syncButtons();
    updateCount();
    renderGrid();
  }

  /* ---- Drawer open / close ---- */

  function drawerEl() { return document.querySelector('[data-wishlist-drawer]'); }

  function openDrawer() {
    var d = drawerEl();
    if (!d) return;
    renderGrid();
    d.hidden = false;
    d.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { d.classList.add('is-open'); });
    });
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var d = drawerEl();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var dialog = d.querySelector('.sj-wd__dialog');
    if (dialog) {
      dialog.addEventListener('transitionend', function h() {
        dialog.removeEventListener('transitionend', h);
        d.hidden = true; d.setAttribute('aria-hidden', 'true');
      });
    } else {
      d.hidden = true; d.setAttribute('aria-hidden', 'true');
    }
  }

  /* ---- Events ---- */

  document.addEventListener('click', function (e) {
    /* Abrir panel desde el corazón del header */
    if (e.target.closest('[data-fav-toggle]')) { e.preventDefault(); openDrawer(); return; }
    /* Cerrar panel */
    if (e.target.closest('[data-wishlist-close]')) { e.preventDefault(); closeDrawer(); return; }
    var d = drawerEl();
    if (d && e.target === d) { closeDrawer(); return; }
    /* Toggle de favorito (corazones y botón "Quitar") */
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var justAdded = toggle(itemFromButton(btn));
    refresh();
    /* Al AGREGAR (no al quitar) se abre el panel de favoritos. */
    if (justAdded) openDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn || btn.tagName === 'BUTTON') return;
    e.preventDefault();
    var justAdded = toggle(itemFromButton(btn));
    refresh();
    if (justAdded) openDrawer();
  });

  document.addEventListener('wishlist:updated', function () {
    syncButtons();
    updateCount();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  /* Sync across tabs */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) refresh();
  });
})();
